import { render } from "./DtRoutesAddUpdateModal.vue?vue&type=template&id=19c98eb8"
import script from "./DtRoutesAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./DtRoutesAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__